import React, { Fragment } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffectOnce } from 'react-use';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Box,
  Fab,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Edit as EditIcon } from '@material-ui/icons';
import { AppBar, Page } from 'components';
import { userStore, reportStore, anketsStore, backNavigationStore } from 'stores';
import { ru } from 'locale';
import { icons, reportItems } from './ReportScreen.mock';
import useStyles from './ReportScreen.styles';

const ReportScreen = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const { backUrl } = backNavigationStore;
  const { path } = useRouteMatch();
  const { report, fetchState } = reportStore;
  const { userData } = userStore;

  useEffectOnce(() => {
    autorun(() => {
      reportStore.getReport(anketsStore.anketId);
    });
  });

  const renderSkeleton = () => {
    return (
      <>
        {reportItems.map(item => {
          return (
            <Box px={2} py={3} key={item}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Skeleton variant="circle" width={48} height={48} />
                </Grid>
                <Grid item xs={10}>
                  <Skeleton variant="text" height={20} width="100%" />
                  <Skeleton variant="text" height={20} width="80%" />
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </>
    );
  };

  const handleBackClick = () => {
    history.goBack();
  };

  const handleFormEdit = () => {
    history.push(`${path}/edit`);
  };

  const renderReport = () => {
    const items = Object.keys(report);

    return (
      <>
        <List aria-label={ru.reportSb}>
          {items.map((name, idx) => {
            const Icon = icons[name];
            const { title, value } = report[name];

            return (
              <Fragment key={name}>
                <ListItem>
                  <ListItemIcon>
                    <Icon />
                  </ListItemIcon>
                  <ListItemText primary={title} secondary={value} />
                </ListItem>
                {idx !== items.length - 1 && <Divider />}
              </Fragment>
            );
          })}
        </List>

        {userData?.role === 'admin' && (
          <Fab
            type="submit"
            color="secondary"
            aria-label={ru.edit}
            className={classes.editButton}
            onClick={handleFormEdit}
          >
            <EditIcon />
          </Fab>
        )}
      </>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <Grid item>
          <AppBar
            title={ru.reportSb}
            onNavButtonClick={handleBackClick}
            backUrl={`${backUrl}#sb-report`}
            typeNavIcon="link"
          />
        </Grid>
        <Grid>
          {fetchState === 'pending' && renderSkeleton()}
          {fetchState === 'fulfilled' && renderReport()}
        </Grid>
      </Grid>
    </Page>
  );
});

export default ReportScreen;
